module.exports = __webpack_public_path__ + "static/media/file-download-circle-green.a8adce84.svg";